<template>
  <v-app class="view">
    <v-dialog
        v-model="EditCustomerDialog"
        max-width="700"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedCustomer" @submit.prevent="onSubmitCustomer">
        <v-card class="pa-8">
          <v-tabs v-model="tab">
            <v-tab>Address</v-tab>
            <v-tab>Map</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="selectedCustomer.name"
                        class="login-input"
                        label="ชื่อลูกค้า"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>

                    <!--<v-select-->
                    <!--:items="[{text:'PJ',value:'PJ'},{text:'MT',value:'MT'},{text:'TT',value:'TT'},{text:'OL',value:'OL'},{text:'FT',value:'FT'}]"-->
                    <!--label="ประเภท"-->
                    <!--v-model="selectedCustomer.type"-->
                    <!--outlined-->
                    <!--&gt;</v-select>-->


                    <v-select
                        v-model="selectedCustomer.business_type"
                        :items="businessList"
                        :loading="businessList.length===0"
                        label="ธุรกิจ"
                        outlined
                    ></v-select>


                    <v-text-field

                        v-model="selectedCustomer.city"
                        class="login-input"
                        label="อำเภอ"
                        outlined
                        placeholder=""
                        readonly
                        required
                    >
                    </v-text-field>


                    <v-text-field

                        v-model="selectedCustomer.credit_amount"
                        class="login-input"
                        hide-details
                        label="วงเงิน"
                        outlined
                        placeholder=""
                        required
                        type="number"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                        v-model="selectedCustomer.tax_no"
                        :rules="[idcardState]"
                        class="login-input"
                        label="หมายเลขผู้เสียภาษี"
                        outlined
                        placeholder=""
                        type="number"
                    >
                    </v-text-field>

                    <v-text-field

                        v-model="selectedCustomer.address"
                        class="login-input"
                        label="ที่อยู่"
                        outlined
                        placeholder=""
                        required
                    >
                    </v-text-field>

                    <v-text-field

                        v-model="selectedCustomer.province"
                        class="login-input"
                        label="จังหวัด"
                        outlined
                        placeholder=""
                        readonly
                        required
                    >
                    </v-text-field>
                    <v-text-field

                        v-model="selectedCustomer.credit_term"
                        class="login-input"
                        hide-details
                        label="เครดิต(วัน)"
                        outlined
                        placeholder=""
                        required
                        type="number"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="selectedCustomer.erp_tel"
                        class="login-input"
                        label="เบอร์โทร"
                        outlined
                        placeholder=""
                        required
                        type="number"
                    >
                    </v-text-field>

                    <!--<v-text-field-->

                    <!--label="ตำบล"-->
                    <!--v-model="selectedCustomer.district"-->
                    <!--required-->
                    <!--outlined-->
                    <!--class="login-input"-->
                    <!--placeholder=""-->
                    <!--&gt;</v-text-field>-->

                    <v-autocomplete
                        v-model="selectedCustomer.district"
                        :items="districtItems"
                        :loading="isLoadingDistricts"
                        :search-input.sync="search"
                        auto-select-first
                        class="login-input"
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="id_name"
                        label="ตำบล"
                        outlined
                        placeholder="ค้นหา"
                        required
                        return-object
                        @change="changeDistrict"
                    >
                      <template v-slot:item="data">
                        {{ data.item.Description }}
                      </template>
                    </v-autocomplete>


                    <v-text-field

                        v-model="selectedCustomer.zip_code"
                        class="login-input"
                        label="รหัสไปรษณีย์"
                        outlined
                        placeholder=""
                        required
                        type="number"
                    >
                    </v-text-field>


                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="selectedCustomer.ship_to"
                        class=""
                        label="หมายเหตุส่งของ"
                        outlined
                        placeholder=""
                        type="text"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="tab-item">
                <v-row>
                  <v-col cols="6">
                    <v-card class="pa-2">
                <span class="caption float-right">
                                    <v-btn class="ml-1" x-small @click="editLocation()">แก้ไข</v-btn></span>

                      <span class="caption">แผนที่
                <span v-if="selectedCustomer.gis_type===CustomerConst.GIS_TYPE_NONE">(ยังไม่ยืนยัน)</span>
                  <span v-if="selectedCustomer.gis_type===CustomerConst.GIS_TYPE_DISTRICT">(ตำบล)</span>
                  <span v-if="selectedCustomer.gis_type===CustomerConst.GIS_TYPE_GOOGLE">(จาก google)</span>
                  <span v-if="selectedCustomer.gis_type===CustomerConst.GIS_TYPE_USER">(ปักแล้ว)</span>
                </span>
                      <v-divider class="mt-2"></v-divider>

                      <a :href="selectedCustomer.cache_lat>0?`https://maps.google.com/?q=${selectedCustomer.cache_lat},${selectedCustomer.cache_lng}`:'#'"
                         :target="selectedCustomer.cache_lat>0?'_blank':'_self'">
                        <v-img
                            v-if="selectedCustomer.district"
                            :src="`https://maps.googleapis.com/maps/api/staticmap?center=${selectedCustomer.district.city}+${selectedCustomer.district.province}&size=320x180&key=AIzaSyC1O0kuADUz8RR8oIsUhR26GEG0CIT_oiI${selectedCustomer.cache_lat>0?'&markers=size:small%7Ccolor:red%7Clabel:X%7C'+selectedCustomer.cache_lat+','+selectedCustomer.cache_lng+'':'&zoom=12'}`"
                            aspect-ratio="1.6"
                            class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                                align="center"
                                class="fill-height ma-0"
                                justify="center"
                            >
                              <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>

                            </v-row>
                          </template>
                        </v-img>
                      </a>
                    </v-card>
                  </v-col>
                  <v-col class="col-6">
                    เซลล์
                    <v-divider class="mb-2"></v-divider>
                    <!--{{customer.cache_sales}}-->

                    <Avatar v-for="sale in sales" v-bind:key="sale.id"
                            :active="sale.enabled"
                            :user="sale"
                            @click.native="openSales()"></Avatar>
                    <v-avatar
                        v-if="!sales || sales.length===0"
                        color="grey"
                        size="64px"
                        @click="openSales()"
                    >
                      <v-icon x-large>mdi-plus</v-icon>
                    </v-avatar>


                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="red--text">
                    กรุณาตรวจสอบพิกัดและยืนยัน
                      หากส่งสินค้าไปตามพิกัดแล้วไม่ถูกต้องเซล์จะต้องรับผิดชอบค่าใช้จ่ายในการขนส่ง
                  </div>
                    <v-checkbox v-if="selectedCustomer"
                                v-model="selectedCustomer.gis_is_confirm"
                                class="mt-0 align-end"
                                hide-details
                                label="ยืนยันพิกัด"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>

            </v-tab-item>
          </v-tabs-items>

          <v-card-actions>
            <v-card-text class="red--text">
              ตั้งแต่วันที่ 1 กย. เป็นต้นไป ลูกค้าใหม่จะต้องยืนยันพิกัดส่งของให้ถูกต้อง ก่อนกดเพิ่ม
            </v-card-text>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="gray" text @click="cancel">
              ยกเลิก
            </v-btn>
            <v-btn :loading="customerLoading" class="close-button" color="primary" fab
                   tile
                   type="submit"
                   width="100">
              <!--<v-icon>mdi-check-bold</v-icon>-->
              เพิ่ม
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>

    <div :style="{
                        paddingLeft:(drawer_width+12)+'px',
                        paddingRight:(12)+'px',

                     }"
         class="list-header">
      <v-row
          class="list-header-row "
      >
        <v-col>
          ชื่อลูกค้า
        </v-col>
        <v-col class="col-md-2 d-none d-md-inline">
          สั่งล่าสุด
        </v-col>
        <v-col class="col-2 col-md-1 text-center ">
          สั่ง
        </v-col>
      </v-row>

    </div>

    <v-content>

      <v-container
          :style="{
                        paddingLeft:drawer_width+'px',
                     }"
          class="fill-height container"
          fluid>


        <CustomerRow v-for="(customer, index) in items"

                     :key="index"
                     :currentIndex="-padItemOffset+startElementIndex+index-padItemAmount"
                     :customer="customer"
                     :style="{
                        left:drawer_width+'px',
                        paddingRight:drawer_width+'px',
                        top:((-padItemOffset+startElementIndex+index-padItemAmount)*itemHeight)+'px'
                     }"
                     class="pad-filter"
        >

        </CustomerRow>

        <LoadingDummy
            :itemHeight="itemHeight"
            :maxElementRender="maxElementRender"
            :scrollY="scrollY"
            :store="store">
        </LoadingDummy>

      </v-container>
    </v-content>
    <v-navigation-drawer
        :width="drawer_width"
        class="nav"
        permanent
        touchless
    >
      <v-card class="pl-2 pt-2 pr-2 pb-2">
        <v-text-field v-model="filter_search_keyword"

                      class="search"
                      clearable
                      hide-details="true"
                      label="ค้นหา"
                      outlined
                      placeholder="ใส่คำค้นหา"
                      @click:clear="clear_reload()"
                      @keydown.enter="reload()"
        ></v-text-field>
      </v-card>

      <v-card :class="{primary:is_star}" class="pa-2" outlined tile
              @click="setFilter('star')">
        ติดดาว
        <v-icon v-if="is_star" class="float-right">mdi-close</v-icon>
      </v-card>
      <v-card :class="{primary:is_pending}" class="pa-2" outlined tile
              @click="setFilter('pending')">
        รออนุมัติ
      </v-card>
      <v-card :class="{primary:is_due}" class="pa-2" outlined tile
              @click="setFilter('due')">
        ค้างชำระ
      </v-card>
      <v-card :class="{primary:is_latest}" class="pa-2" outlined tile
              @click="setFilter('latest')">
        ล่าสุด
      </v-card>


      <FilterCurrent :filter="store.filter" :setFilter="setFilter"></FilterCurrent>


      <!--<GmapMap ref="mapRef"-->
      <!--:center="{lat:lat, lng:lng}"-->
      <!--:zoom="20"-->
      <!--map-type-id="roadmap"-->
      <!--style="width: 100px; height: 100px">-->
      <!--</GmapMap>-->

      <v-btn
          absolute
          class=""
          color="primary"
          style="width: 150px;left: 50%;bottom: 75px;margin-left: -75px" @click="newCustomer">
        สร้างลูกค้า
      </v-btn>

    </v-navigation-drawer>

  </v-app>
</template>
<style lang="scss" scoped>

.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 40px;
}


.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.list-header {
  position: fixed;
  top: 60px;
  z-index: 1;
  width: 100%;
  font-size: 16px;

}

@media (min-height: 700px) {
  .list-header {
    position: fixed;
    top: 60px;
    z-index: 1;
    width: 100%;

  }
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.tab-item {
  margin-top: 0px;
  min-height: 400px;
}

</style>
<script lang="ts">
import {User} from '@/models/User'
import {Component, Watch} from 'vue-property-decorator'
import CustomerRow from '../components/Customer/CustomerRow.vue'
import FilterCurrent from '../components/FilterCurrent.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import Avatar from '../components/User/Avatar.vue'
import {Customer, CustomerConst} from '../models/Customer'
import Helper from '../services/Helper.js'
import ListView from './ListView'

@Component({
  components: {LoadingDummy, CustomerRow, FilterCurrent, Avatar},
})
export default class ViewCustomer extends ListView<Customer> {

  CustomerConst = CustomerConst
  CreateCustomerDialog = false

  store = this.$store.state.customers
  commit_prefix = 'customers'

  drawer_ratio = 0.2

  base_url = Helper.setting.customer.getListAPI

  sales: User[] | null = null

  customerLoading = false
  EditCustomerDialog = false
  selectedCustomer: Customer | null = null

  isForceReload = true

  // pagination = {
  //   ascending: true,
  //   sortBy: 'name',
  //   rowsPerPage: 5,
  //   page: 1,
  // }
  validIdCustomer = false
  validIdChecksum = false
  lat = 0
  lng = 0
  entries = [{
    id: 0,
    name: '',
    'province_id': 0,
    city: {
      name: '',
      province: {
        name: '',
      },
    },
  }]
  countDistricts = 0
  isLoadingDistricts = false
  search = ''
  tab = 0
  businessList: any = []

  get districtItems() {
    return this.entries.map(entry => {
      let district = entry.name

      if (!entry.hasOwnProperty('city')) {
        return Object.assign({}, entry, {
          id_name: '000000|' + district,
          name: district,
          city: '',
          province: '',
          Description: district,
        })
      }

      let city = entry.city.name
      let province = entry.city.province.name
      if (entry.province_id == 10) {
        district = 'แขวง' + district
        // city =  city
        province = '' + province
      } else {
        district = 'ต.' + district
        // city = 'อ.' + city
        // province = 'จ.' + province
      }
      const Description = entry.name + ' > ' + entry.city.name + ' > ' + entry.city.province.name
      return Object.assign({}, entry, {
        id_name: entry.id + '|' + district,
        name: district,
        city: city,
        province: province,
        Description,
      })
    })
  }

  async editCustomer(customer: Customer) {
    this.customerLoading = true

    this.EditCustomerDialog = true

    if (customer.id) {
      this.selectedCustomer = await (new Customer()).load<Customer>(customer.id)
    }

    this.customerLoading = false

  }

  newCustomer() {
    this.tab = 0
    let customer = new Customer()
    const customers_default_value = localStorage.getItem('customers_default_value')

    if (customers_default_value) {
      let default_value = JSON.parse(customers_default_value)

      if (default_value === null) {
        default_value = {}
      }
      customer.type = default_value.type
      customer.business_type = default_value.business_type
      customer.credit_amount = default_value.credit_amount
      customer.credit_term = default_value.credit_term
      customer.district = default_value.district
      customer.province = default_value.province
      customer.zip_code = default_value.zip_code
    }


    if (['PJ', 'MT', 'TT', 'OL', 'FT', 'HM'].includes(this.$store.state.$user.department)) {
      customer.type = this.$store.state.$user.department
    } else {
      customer.type = 'PJ'
    }
    // console.log(customer.type)

    this.selectedCustomer = customer
    this.EditCustomerDialog = true

    this.loadBusiness()

    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(this.callBackFunc)
    // }
    //
    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   console.log('map', map)
    // })


  }

  async loadBusiness() {
    if (this.businessList.length > 0) return
    const url = Helper.setting.business.getListAPI
    try {
      const data: any = await Helper.get(url).then<{ data: any }>(({data}) => data)
      this.businessList = data.business

      this.businessList = this.businessList.map((value) => {
        return {
          value: value['code'],
          text: value['name'],
        }
      })
      console.log(this.businessList)


    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }

  }


  cancel() {

    this.EditCustomerDialog = false
  }

  idcardState(data) {
    //this.idCardCheck = false
    if (data === null || typeof data === 'undefined') {
      return false
    }
    const is_13 = /^([0-9]{13})$/.test(data.replace(/ /g, ''))
    if (!is_13) {
      this.validIdCustomer = false
      this.validIdChecksum = false
      return 'กรุณากรอกให้ครบ'
    }

    if (data == '0000000000000') {
      this.validIdCustomer = true
      this.validIdChecksum = true
      return true
    }

    // this.validIdCustomer = true
    // return true

    let sum = 0
    for (let i = 0; i < 12; i++)
      sum += parseInt(data[i]) * (13 - i)
    if ((11 - (sum % 11)) % 10 === parseInt(data[12])) {
      this.validIdCustomer = true
      this.validIdChecksum = true
      return true
    } else {
      this.validIdChecksum = false
    }
    this.validIdCustomer = true
    return 'หมายเลขไม่ถูกต้อง'
  }

  async onSubmitCustomer() {
    if (!this.validIdCustomer) {
      alert('หมายเลขผู้เสียภาษีไม่ถูกต้อง')
      return
    }

    if (!(this.selectedCustomer?.city)) {
      alert('ไม่พอข้อมูลอำเภอ ติดต่อแอดมิน')
      return
    }

    // if (!this.selectedCustomer?.gis_is_confirm
    //     || !this.selectedCustomer?.gis_lat
    //     || !this.selectedCustomer?.gis_lng
    // ) {
    //   this.$root.$emit('onWarning', {message: 'ต้องยืนยันพิกัด gis ก่อน'})
    //   return
    // }


    this.customerLoading = true
    const isNew = this.selectedCustomer?.id === null

    this.selectedCustomer = Object.setPrototypeOf(this.selectedCustomer, Customer.prototype)

    if (this.selectedCustomer) {
      if (!this.validIdChecksum) {
        this.selectedCustomer.erp_remark1 = '*หมายเลขผู้เสียภาษีไม่ถูกต้อง*'
      }

      this.$store.commit('update_default_customer', this.selectedCustomer)

      localStorage.setItem('customers_default_value', JSON.stringify(this.$store.state.customers.default_value))

      try{
        let customer = await this.selectedCustomer.save<Customer>()
      }catch (e){
        this.$root.$emit('onError', {error: e})
      }
      this.customerLoading = false


    }
    this.selectedCustomer = null
    this.EditCustomerDialog = false
    this.reload()
  }

  created() {

  }

  callBackFunc(position) {
    this.lat = position.coords.latitude
    this.lng = position.coords.longitude
  }

  changeDistrict(val: any) {
    console.log(val)
    // this.selectedCustomer.district = val.district
    if (this.selectedCustomer && val && val.city)
      this.selectedCustomer.city = val.city
    if (this.selectedCustomer && val && val.province)
      this.selectedCustomer.province = val.province
    // setTimeout(() => {
    //   this.selectedCustomer.district = val.district
    // }, 1)
  }

  @Watch('search')
  async onSearchChanged(val: string, oldValue: string) {
    // Items have already been loaded
    // if (this.districtItems.length > 0) return
    //
    if (val === null) return
    if (this.districtItems.length > 0) {
      const found = this.districtItems.filter(obj => val == obj.name)
      if (found.length >= 1) {
        return
      }
    }


    // // Items have already been requested
    // if (this.isLoadingDistricts) return
    console.log([oldValue, val])

    if (val && val.length < 2) return

    this.isLoadingDistricts = true

    // Lazily load input items
    const url = Helper.setting.district.getListAPI + '?keyword=' + val
    try {
      const data: any = await Helper.get(url).then<{ data: any }>(({data}) => data)
      this.countDistricts = data.count
      this.entries = data.districts
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadingDistricts = false
  }

  async editLocation() {
    if (!this.selectedCustomer) return

    let keyword = ''
    if (this.selectedCustomer.district) {
      keyword = `${this.selectedCustomer.name} ${this.selectedCustomer.address} ${this.selectedCustomer.district.name} ${this.selectedCustomer.district.city} ${this.selectedCustomer.district.province} ${this.selectedCustomer.zip_code}`
    }

    this.$root.$emit('openLocationPicker', {
      option: {
        keyword: keyword
        , lat: this.selectedCustomer.cache_lat, lng: this.selectedCustomer.cache_lng,
      }, onApply: async (result) => {
        if (!this.selectedCustomer) return
        // this.google_isLoad = true
        console.log('editLocation apply', result)

        this.selectedCustomer.gis_lat = result.lat
        this.selectedCustomer.gis_lng = result.lng


        // this.google_isLoad = false
      },
    })
  }

  private refreshSale() {
    this.sales = []
    if (!this.selectedCustomer) return
    console.log('customer sales', this.selectedCustomer.sales)
    for (let index in this.selectedCustomer.sales) {
      let sale = this.selectedCustomer.sales[index]
      if (!sale || !sale.user_code) continue
      console.log('sales', sale)
      if (this.$store.state.users.code_map.hasOwnProperty(sale.user_code)) {
        let user = this.$store.state.users.code_map[sale.user_code]
        user.orderUser = sale
        this.sales.push(user)
      } else {
        let sale2 = new User()
        sale2.department = '??'
        sale2.nickname = sale.user_code
        sale2.picture = null
        sale2.orderUser = sale
        this.sales.push(sale2)
      }
    }
  }

  private openSales() {
    this.$root.$emit('openSales', {
      sales: this.sales, onApply: async (sales) => {
        if (this.selectedCustomer) {
          this.selectedCustomer.sales = sales
          this.refreshSale()
        }
      },
    })
  }
}
</script>
<style lang="scss" scoped>
.view {

  .fill-height {
    padding-left: 150px;
  }
}

.nav {
  position: fixed;
  margin-top: 60px;

}
</style>
